import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'
import Table, { TableHead, TableBody, TableRow, TableCell } from 'components/CollapsibleTable'
import {authorizedLink} from 'utils'

export class UseOfFunds extends Component {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () =>
    <div className={this.props.className}>
      <div className={styles.detail}>
        {this.props.dealSheet.useOfFunds}
      </div>
      {this.props.dealSheet.fundsUseInfographic ?
        <img className={styles.infographic} src={authorizedLink(this.props.dealSheet.fundsUseInfographicUrls.medium)} alt="Use of funds graphic" />
      :
        this.props.dealSheet.fundsUses &&
          <Table className={styles.table}>
            <TableHead>
              <TableRow>
                <TableCell>Category</TableCell>
                <TableCell>Percentage</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.dealSheet.fundsUses.map(fundsUse =>
                <TableRow key={fundsUse.id}>
                  <TableCell mobileHeading>{fundsUse.category}</TableCell>
                  <TableCell mobileLabel={'Percentage'}>{fundsUse.percentage}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
      }
    </div>
}

const styles = StyleSheet({
  detail: {
    fontSize: '13px',
    lineHeight: '20px',
    paddingRight: 75,
    marginBottom: 50,
  },
  table: {
    marginBottom: 50,
  },
  infographic: {
    maxWidth: 368,
    maxHeight: 368,
  }
})

export default UseOfFunds